import { FC } from 'react';
import styles from './styles.module.css';

const InstructionsView: FC = () => (
  <div className={styles.wrapper}>
    <p>
      <a
        className={styles.link}
        href="https://limbic-clinic-admin-portal-versioning.s3.eu-west-2.amazonaws.com/latest/Limbic_Clinic_Admin_Portal_Instructions_for_Use.pdf">
        Instructions For Use
      </a>
    </p>

    <p>
      <a
        className={styles.link}
        href="https://limbic-clinic-admin-portal-versioning.s3.eu-west-2.amazonaws.com/policies/Limbic_Care_Terms_of_Use_(UK).pdf">
        Terms of Use
      </a>
    </p>

    <p>
      <a
        className={styles.link}
        href="https://limbic-clinic-admin-portal-versioning.s3.eu-west-2.amazonaws.com/policies/Limbic_Care_Privacy_Notice_(UK).pdf">
        Privacy Notice
      </a>
    </p>
  </div>
);

export default InstructionsView;
